module.exports = __webpack_public_path__ + "img/user-5.7419fd9b.png";